<div class="col-md-12">
  <h3 class="">Assign User's DOA</h3>
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
<br />
<div class="panel panel-primary">
  <div class="panel-heading">Emplployee Information</div>
  <div class="panel-body">
  <div class="form">
      <form name="form" (ngSubmit)="f.form.valid && OnSubmit()" #f="ngForm"  novalidate>
    <div class="form-group row">
      <label for="BehalfCAIValid" class="col-sm-2 col-form-label">User Provisioning ID:</label>
      <div class="col-sm-4">
      
          <input  id="BehalfCAIValid" placeholder="User Provisioning ID"  (selectItem)="selectedItem($event)" name ="BehalfCAIValid" type="text" class="form-control" [(ngModel)]="BehalfProvisioningID" [ngbTypeahead]="searchUserProvisioningID" #BehalfCAIValid="ngModel" [ngClass]="{ 'is-invalid': f.submitted && BehalfCAIValid.invalid }" required/> 
                                                <div *ngIf="f.submitted && BehalfCAIValid.invalid" class="invalid-feedback invalid-display">
                                                        <div *ngIf="BehalfCAIValid.errors?.['required']">*User CAI is required</div>
                                                </div> 
      </div>
    </div>
    <div class="form-group row">
      <label for="BehalfNameValid" class="col-sm-2 col-form-label">User Name:</label>
      <div class="col-sm-4">
          <input [(ngModel)]="BehalfName"  placeholder="User name"  readonly="true" name="BehalfNameValid"
          class="form-control" id="BehalfNameValid" #BehalfNameValid="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && BehalfNameValid.invalid }" required>
          <div *ngIf="f.submitted && BehalfNameValid.invalid" class="invalid-feedback invalid-display">
                  <div *ngIf="BehalfNameValid.errors?.['required']">*User Name is required</div>
          </div>
      </div>
    </div>
    <div class="form-group row">
        <label for="dpFrom" class="col-sm-2 col-form-label">From Date:</label>
          <div class="col-sm-3">
            <input class="form-control" placeholder="dd-mm-yyyy"
            name="dpFrom" id="dpFrom" [(ngModel)]="FrmDt" [minDate]="minDate"  ngbDatepicker #d="ngbDatepicker" #dpFrom="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpFrom.invalid }" required> 
            <div *ngIf="f.submitted && dpFrom.invalid" class="invalid-feedback invalid-display">
              <div *ngIf="dpFrom.errors?.['required']">*From date is required</div>
            </div>
          </div>
           <div class="col-sm-1" style="padding-left: 0px;">
              <button class="glyphicon glyphicon-calendar" (click)="d.toggle()" type="button"></button>
           </div>
           
    </div>
    <div class="form-group row">
        <label for="dpTo" class="col-sm-2 col-form-label">To Date:</label>
           <div class="col-sm-3">
            <input class="form-control" placeholder="dd-mm-yyyy"
            name="dpTo" id="dpTo" [(ngModel)]="ToDt" [minDate]="minDate" ngbDatepicker #dt="ngbDatepicker" #dpTo="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpTo.invalid }" required> 
            <div *ngIf="f.submitted && dpTo.invalid" class="invalid-feedback invalid-display">
              <div *ngIf="dpTo.errors?.['required']">*To date is required</div>
            </div>
          </div>
           <div class="col-sm-1" style="padding-left: 0px;">
              <button class="glyphicon glyphicon-calendar" (click)="dt.toggle()" type="button"></button>
           </div>
           
    </div>
    <div class="form-group row">
      <div class="col-sm-2 col-form-label"></div>
      <div class="col-sm-4">
        <button class="btn btn-primary" [disabled]="user.Role=='ReadOnly'">Assign User</button>
      </div>
    </div>
    </form>
  </div>
  <div class="clearfix"></div>
</div>
</div>
  <br /> <br />
  <table class="table table-bordered"  *ngIf="assignUsers != undefined">
    <thead>
      <tr>
        <th scope="col">Provisioning ID</th>
        <th scope="col">Name</th>
        <th scope="col">From Date</th>
        <th scope="col">To Date </th>
        <!-- <th scope="col" >Remove</th> -->
      </tr>
    </thead>
    <tbody >
      <tr *ngFor="let user of assignUsers | paginate: config; let i = index">
        <td>{{ user.BehalfCAI }}</td>
        <td>{{ user.BehalfName }}</td>
        <td>{{ user.FromDate |date}}</td>
        <td>{{ user.ToDate | date }}</td>
      
      </tr>
    </tbody>
  </table>
  <pagination-controls *ngIf="assignUsers != undefined" (pageChange)="pageChanged($event)"></pagination-controls>


</div>